import { DEMO_MODE_INITIATOR_ACTIVE, DEMO_MODE_TLC_ACTIVE } from './types'

export const triggerDemoModeInitiator =
    (status = true) =>
    async (dispatch: any) => {
        dispatch({
            type: DEMO_MODE_INITIATOR_ACTIVE,
            payload: {
                status,
            },
        })
    }

export const entrerDemoModeTlc = (status: any) => async (dispatch: any) => {
    dispatch({
        type: DEMO_MODE_TLC_ACTIVE,
        payload: {
            status,
        },
    })
}
